import React, { useState } from 'react';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import UserReviewsManagement from '../../../components/siteadmin/UserReviewsManagement/UserReviewsManagement';
import Loader from '../../../components/Loader/Loader';
import userReviewsQuery from './userReviewsQuery.graphql';
import { withQuery } from '../../../hoc/withGraphql';

import s from './UserReviews.css';

function UserReviews(props) {
    const { userReviews, userReviews: { loading } } = props;
    const [reviewsState, setReviewsState] = useState({
        currentPage: 1,
        searchList: ''
    });
    const { searchList, currentPage } = reviewsState;

    const setStateVariable = (variables) => {
        setReviewsState(prevObject => ({ ...prevObject, ...variables }));

    }

    return loading ? <Loader type="text" /> :
        <UserReviewsManagement
            currentPage={currentPage}
            searchList={searchList}
            setStateVariable={setStateVariable}
            userReviews={userReviews}
        />

}

export default compose(
    withStyles(s),
    withQuery(userReviewsQuery, {
        name: 'userReviews',
        options: (props) => ({
            variables: {
                currentPage: 1,
                searchList: '',
            },
            fetchPolicy: 'network-only',
            ssr: false
        })
    })
)(UserReviews);